import React, {Component} from 'react'
import Slide from '../Globals/Slide/slide'
import './estilo.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'

class SelecionTipo extends Component{
    constructor(props){
        super(props);
        this.state={

        };
    }

    componentDidMount(){
        // console.log(this.props);
    }

    pilotos=()=>{
        let url='/nuevoViaje/'+'pilotos';
         this.props.history.push(url);
      }
      tcs=()=>{
        let url='/nuevoViaje/'+'tcs';
         this.props.history.push(url);
      }
      pilotossap=()=>{
        let url='/nuevoViaje/'+'pilotossap';
         this.props.history.push(url);
      }

    render(){
        return(
            <div>
            <Slide />
            <div className='borde'>
                    <div className="row">
                        <aside className="col-sm-4" onClick={this.pilotos}>
                            <div className="card-banner  overlay-grad5" style={{ height: 250 }}>
                                <div className="card-body text-white">
                                    <h5 className="card-title">Recogimiento de pilotos</h5>
                                    <p className="card-text">Generar un itineario personalizado</p>
                                </div>
                            </div>
                        </aside>
                        <aside className="col-sm-4" onClick={this.tcs}>
                            <div className="card-banner  overlay-grad6" style={{ height: 250 }}>
                                <div className="card-body text-white">
                                    <h5 className="card-title">Recogimiento TCS</h5>
                                    <p className="card-text">Generar un itineario personalizado</p>
                                </div>
                            </div>
                        </aside>
                        <aside className="col-sm-4" onClick={this.pilotossap}>
                            <div className="card-banner  overlay-grad7" style={{ height: 250 }}>
                                <div className="card-body text-white">
                                    <h5 className="card-title">Recogimiento pilotos SAP</h5>
                                    <p className="card-text">Generar un itineario personalizado</p>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        )
    }
}
export default SelecionTipo;


// WEBPACK FOOTER //
// ./src/Components/Programacion/selecionTipo.js